import { TemplateConfig } from '../types';

export const industryFitSpreadConfig: TemplateConfig = {
  id: 'industry-fit-spread',
  name: '某个行业是否合适',
  description: '分析进入某个行业的优势、短板与发展结果',
  cardCount: 4,
  
  fieldDefaults: {
    title: '这个行业是否合适',
    customerQuestion: '分析我是否适合进入某个行业发展。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌'
    ],
    cardInfos: [
      '假如要在这个行业发展，我的优点是什么',
      '假如要在这个行业发展，我的缺点是什么',
      '入行的发展',
      '入行的结果'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1677ff',
    backgroundColor: '#e6f4ff',
    icon: '🧭'
  }
};
